import styled from 'foundations-theming/utils';
export const FiltersWrapper = styled.div.withConfig({
  displayName: "FiltersWrapper"
})(["button[role='combobox']{width:auto;font-weight:600;border:none;&[data-selected-values]{background-color:", ";}}"], ({
  theme
}) => theme.color['fill-field-hover']);